var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2727 5.49449C8.00003 5.85627 5.45455 8.63087 5.45455 12C5.45455 15.615 8.38504 18.5455 12 18.5455C15.3691 18.5455 18.1437 16 18.5055 12.7273H12C11.5983 12.7273 11.2727 12.4017 11.2727 12V5.49449ZM4 12C4 7.58172 7.58172 4 12 4C12.4017 4 12.7273 4.32561 12.7273 4.72727V11.2727H19.2727C19.6744 11.2727 20 11.5983 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM13.7514 4.47393C13.9381 4.33691 14.1788 4.29696 14.3997 4.36634C16.8886 5.14803 18.852 7.11144 19.6336 9.60026C19.703 9.82116 19.6631 10.0619 19.526 10.2486C19.389 10.4352 19.1713 10.5455 18.9398 10.5455H14.1818C13.7802 10.5455 13.4545 10.2198 13.4545 9.81818V5.06019C13.4545 4.82865 13.5648 4.61094 13.7514 4.47393ZM14.9091 6.13472V9.09091H17.8653C17.2297 7.81219 16.1878 6.77031 14.9091 6.13472Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.40492365.svg";
export { ForwardRef as ReactComponent };